<script>
    import Twitter from './Twitter.svelte';
    import { Circle3 } from 'svelte-loading-spinners';
    import { userStore, tweetStore } from './stores.js';
    import { onMount } from 'svelte';

    let username;
    let url;
    let tweets;
    let tweetUrl = '-';
    let sentiment;
    let sentimentReason;
    let showTwitter = false;
    let showSentiment = false;

    onMount(() => {
        // set showSentiment to true if URL params sentimen=true
        const params = new URLSearchParams(window.location.search);
        showSentiment = params.get('sentimen') === 'true';
    });

    userStore.subscribe(({ username: newUsername, url: newUrl, tweets: newTweets }) => {
        username = newUsername;
        url = newUrl;
        showTwitter = false; // Add this line
    });
    tweetStore.subscribe(({ tweets: newTweets }) => {
        tweets = newTweets;
    });

    async function handleClick(tweet) {
        showTwitter = false;
        tweetUrl = tweet;
        sentiment = null;
        sentimentReason = null;
        
        // Use setTimeout to delay the execution
        setTimeout(() => {
            showTwitter = true;
            getSentiment(tweet);
        }, 0);
    }

    async function getSentiment(tweet) {
        const response = await fetch(`https://sentiment.graph.gv.my/?tweeturl=${tweet}&lang=ms`);
        if (response.ok) {
            const data = await response.json();
            sentiment = data.content.split('|')[0];
            sentimentReason = data.content.split('|')[1];
        } else {
            sentiment = 'Error';
            sentimentReason = 'Error';
        }
    }

    function positifSentimen() {
        return (sentiment === 'POSITIF' || sentiment === 'POSITIVE');
    }

</script>
<div class="border-zinc-700 border-2 rounded-r-xl mb-2 ml-2">
    <a href={url} target="_blank" class="">
        <div class="text-white font-bold text-2xl overflow-hidden overflow-ellipsis whitespace-nowrap p-3">{username}</div>
    </a>
    <hr class="border-zinc-700 ml-2 mr-2">
    {#each tweets as tweet}
        <a href={tweet} target="_blank" on:click|preventDefault={handleClick(tweet)}>
            <div class="text-white font-bold overflow-hidden overflow-ellipsis whitespace-nowrap p-3">{tweet}</div>
        </a>
    {/each}
</div>

{#if showTwitter && tweetUrl != '-' && showSentiment} 
    {#if sentiment}
        <div class="border-zinc-700 border-2 rounded-r-xl mb-2 ml-2">
            <div class="text-white">
                <div class="font-bold text-2xl p-3 uppercase {positifSentimen() ? 'text-green-400' : 'text-rose-600'}">{ sentiment }</div>
                <hr class="border-zinc-700 ml-2 mr-2">
                <div class="text-white p-3">{ sentimentReason }</div>
            </div>
        </div>
    {:else}
        <div class="flex justify-center items-center h-full">
            <Circle3 size="100" unit="px" duration="1s" />
        </div>
    {/if}

{/if}


<div class="p-1 absolute top-25 left-20 w-1/6 text-zinc-700 ">
    {#if showTwitter && tweetUrl != '-' } 
        <Twitter { tweetUrl } />
    {/if}
</div>